import styled from '@emotion/styled';

export const BlurredImageContainerStyled = styled.div`
  position: relative;
`;
